module.exports = __webpack_public_path__ + "static/media/logout.80e65d76.svg";